/** 版本套餐路由 */
export default [
    {
        name: 'versionPackage',
        path: 'versionPackage',
        meta: { title: '版本套餐' },
        component: () => import('@/pages/versionPackage/index.vue')
    },
    {
        name: 'versionPackage-info',
        path: 'versionPackage/info',
        meta: { title: '版本套餐 / 创建' },
        component: () => import('@/pages/versionPackage/info.vue')
    }
]
